import {setOrFallbackValue} from './helper';
export default class Address {
    constructor(properties) {
        this.street = setOrFallbackValue(properties, 'street', '');
        this.streetNumber = setOrFallbackValue(properties, 'streetNumber', '');
        this.suburb = setOrFallbackValue(properties, 'suburb', null);
        this.additional1 = setOrFallbackValue(properties, 'additional1', '');
        this.additional2 = setOrFallbackValue(properties, 'additional2', '');
        this.city = setOrFallbackValue(properties, 'city', '');
        this.area = setOrFallbackValue(properties, 'area', '');
        this.postcode = setOrFallbackValue(properties, 'postcode', '');
        this.state = setOrFallbackValue(properties, 'state', '');
        this.country = setOrFallbackValue(properties, 'country', '');
        this.title = setOrFallbackValue(properties, 'title', '');
        this.firstName = setOrFallbackValue(properties, 'firstName', '');
        this.lastName = setOrFallbackValue(properties, 'lastName', '');
        this.company = ('' === setOrFallbackValue(properties, 'company', ''))
            ? 'Tyroola International Pty Ltd' : properties.company;
        this.email = setOrFallbackValue(properties, 'email', '');
        this.telephone = setOrFallbackValue(properties, 'telephone', '');
    }
}
